module.exports = __webpack_public_path__ + "img/mineIcon1.8879cf64.png";